import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../../services/api';
import Navbar from '../shared/Navbar';

type VerificationState = 'verifying' | 'verified' | 'error';

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState<VerificationState>('verifying');
  const [message, setMessage] = useState('Verifying your email…');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setState('error');
      setMessage('This verification link is missing its token.');
      return;
    }

    api.verifyEmail(token)
      .then(() => {
        setState('verified');
        setMessage('Your email is verified. You can now sign in.');
      })
      .catch((error: Error) => {
        setState('error');
        setMessage(error.message || 'Email verification failed.');
      });
  }, [searchParams]);

  return (
    <div className="app">
      <Navbar />
      <main className="app-main">
        <div className="content-container auth-container">
          <div className="tm-surface auth-card">
            <h2 className="auth-title">
              {state === 'verified' ? 'Email Verified' : 'Verify Email'}
            </h2>
            <p className={state === 'error' ? 'ml-error' : 'auth-subtitle'}>
              {message}
            </p>
            {state !== 'verifying' && (
              <div className="auth-links">
                <Link to="/login">
                  {state === 'verified' ? 'Sign in' : 'Back to sign in'}
                </Link>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default VerifyEmailPage;
